import { render, staticRenderFns } from "./FormAssociante.vue?vue&type=template&id=635c740a"
import script from "./FormAssociante.vue?vue&type=script&lang=js"
export * from "./FormAssociante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports